export const setAriaLabelledByToElement = (elementClassname, idToAssociate) => {
    const e = document.getElementsByClassName(elementClassname).item(0);
    e && e.setAttribute("aria-labelledby", idToAssociate);
};
